import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { KsStageRow } from '../../core/kickstart/kickstart.types';
import { IconComponent } from '../icon/icon';

/**
 * FLOW-402 (DOC-89-A §5, UI-DA-89-A-05) — the one stage row, the same for the
 * client, the agent and Ops: *Submitted → Being assessed → Offer → Signed →
 * Paid out*.
 *
 * **The stage is the record's; this draws it and works nothing out.** The
 * back end's `stage_row` says which step is reached and which are passed. The
 * marking is the step's own — a tick, a filled dot, a plain ring — readable
 * without colour, so no colour token here carries meaning. No percentage, no
 * time estimate, no ending: a declined, withdrawn or lapsed application shows
 * the stage it reached and the page's own status line says what happened.
 */
@Component({
  selector: 'app-stage-row',
  imports: [IconComponent],
  template: `
    <ol class="stage-row" aria-label="Application stage" data-testid="stage-row">
      @for (step of row().steps; track step.key) {
        <li
          class="stage-row__step"
          [attr.data-state]="step.state"
          [attr.aria-current]="step.state === 'reached' ? 'step' : null"
          [attr.data-testid]="'stage-' + step.key"
        >
          <span class="stage-row__marker" aria-hidden="true">
            @if (step.state === 'passed') {
              <app-icon name="check" [size]="12" />
            }
          </span>
          <span class="stage-row__label">{{ step.label }}</span>
        </li>
      }
    </ol>
  `,
  styleUrl: './stage-row.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StageRowComponent {
  readonly row = input.required<KsStageRow>();
}
